<template>
    <div class="col-md-6 offset-md-3" style="padding:15px">

        <div id=loginDiv>
                
            <router-link to="/">
                <img id="logoLoginPage" src="/images/openplan.png" alt="logo Prolendar">
            </router-link>
            <div>
                <h2 >Activate Account</h2>
            </div>
            <div v-if="isVerified" class="invalid-feedback" style="margin-bottom:18px; text-align:center">Account has been verified. Please, set up password to the account below.</div>
            <div v-else class="invalid-feedback">{{errorMessage}}</div>
            <form @submit.prevent="onSubmit">
            <div class="form-group">
                <label for="username">Username</label>
                <input readonly type="text" placeholder="Username" v-model.trim="v$.username.$model" name="username" class="form-control" :class="{ 'is-invalid': submitted && v$.username.$error }" />
                <div v-if="submitted && v$.username.required.$invalid" class="invalid-feedback">Username is required</div>
            </div>

            <div class="form-group">
                <label htmlFor="password">Password</label>
                <input type="password" placeholder="New Password" v-model.trim="v$.password.$model" name="password" class="form-control" :class="{ 'is-invalid': submitted && v$.password.$error }" />

                <div v-if="submitted && v$.password.required.$invalid" class="invalid-feedback">Password is required</div>
            </div>

            <div class="form-group" style="margin-bottom:35px">
                <label htmlFor="password">Confirm Password</label>
                <input type="password" placeholder="Confirm Password" v-model.trim="v$.confirmPassword.$model" name="confirmPassword" class="form-control" :class="{ 'is-invalid': submitted && v$.confirmPassword.$error }" />

                <div v-if="submitted &&v$.confirmPassword.sameAsPassword.$invalid" 
                class="invalid-feedback">Password needs to match</div>
            </div>

            <div class="form-group">
                <button style="width:100%" class="btn btn-edit" >Activate Account</button>
                <!-- <img v-show="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" /> -->
            </div>

            <!-- <div v-if="error" class="alert alert-danger">{{error}}</div> -->

            <!-- MODAL IS HERE -->
                <modal  :scrollable="true" name="submissionFailure" @before-open="beforeOpen" height="auto" :minHeight="150" width="400">
                    <div class=""  role="document">
                        <div class="">
                            <!-- Modal content-->
                            <submissionFailure/>			  			 					
                        </div>
                    </div>
                </modal>
                
            </form>
        </div>
    </div>
</template>

<style scoped>
#tableForGooglePlay{
    margin: auto;
    width: 40%;
    margin-top: 13px
}

#loginDiv{
    margin: auto;
    width: 330px;
    padding: 20px;
    border-radius: 6px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    background-color: white;
}
#logoLoginPage{
    height: auto;
        width: 70%;
    display: block;
    margin-left: auto;
    margin-right: auto;    
}

h2{
    text-align:center; 
    font-size: 20px; 
    color: black; 
    font-style: bolder;
    
}
#footerLoginDiv{
    border-top: 1px solid rgb(182, 179, 179);
    height: 30px;
}
</style>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { sameAsField } from '@/_helpers/validators';
import { router } from '@/_helpers';
import { authenticationService } from '@/_services';

export default {
    data(){
        return {
            username:"",
            password:"",
            confirmPassword:"",
            loading: false,
            error: '',
            submitted:false,
            token:'',
            isVerified:false,
            errorMessage: '',
            firstName: '',
            lastName: '',
           role:''
        }
    },
    setup: () => ({ v$: useVuelidate() }),
    validations: {
      username: { required },
      password: { required },
      confirmPassword:{
          required,
          sameAsPassword:sameAsField('password')
      }
    },
    beforeCreate(){
        authenticationService.logout();
    },
    mounted(){
        this.token = this.$route.params.token
        //console.log(this.token)
        this.verifyAccount();
    },
     methods: {
        submissionFailure: function(){
            this.$modal.show('submissionFailure');
        },
        verifyAccount(){
            this.$http.get('/users/confirmaccount?token='+this.token, {
                               
                            
                            }).then((response) => {
                                this.isVerified = true;
                                console.log(response);
                                this.id = response.data.id
                                this.username = response.data.email
                                this.email = response.data.email
                                this.firstName = response.data.firstName
                                this.lastName = response.data.lastName
                                this.role = response.data.role
                                if (this.role == '' || this.role == undefined)
                                    this.role = 'Owner'
                            }).catch(err => console.log(err.message));
                                // this.submitted=false

                        
        },
        onSubmit () {
            this.submitted = true;

            // stop here if form is invalid
            this.v$.$touch();
            if (this.v$.$invalid) {
                return;
            }

            this.loading = true;

             this.$http.put('/users/', {
                            id:this.id,
                            firstName: this.firstName,
                            lastName: this.lastName,
                            username:this.username,
                            email:this.email,
                            password: this.password,
                            isActive:true,
                            role:this.role
                         }).then(() => {
                        this.$router.push('/successfulactivation/:token')
                        this.username=''
                        this.password = ''
                        this.confirmPassword=''
                        }, () => {
                            // alert('error')
                            this.loading = false
                            this.submissionFailure()
                            // this.submitted=false
                        //  this.infoError = true
                        //  this.loader = false
                            this.password = ''
                            this.confirmPassword=''
                        })
        }
    }
}
</script>